export const PageWrapper = ({ children }: any) => (
  <div className="page-wrapper">{children}</div>
);



// WEBPACK FOOTER //
// ./src/shared/PageWrapper.tsx